import React from "react";
import { useTranslation } from 'react-i18next';
import { DataBox } from "./DataBox";
import { PageHeader } from "./PageHeader";
export default () => {
    
const { t } = useTranslation();
return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}